(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-utility"] && !Shopify.designMode) return;
  try {
    window.SquirrellyCart = (function () {
    function countEls() {
      return document.querySelectorAll('[data-cart-count]');
    }

    function setCount(n) {
      countEls().forEach(function (el) {
        var changed = el.textContent !== String(n);
        el.textContent = n;
        el.hidden = !(n > 0);
        if (changed && n > 0) {
          el.classList.remove('is-bump');
          void el.offsetWidth;
          el.classList.add('is-bump');
        }
      });
      var link = document.querySelector('[data-cart-link]');
      if (link) {
        link.setAttribute('aria-label', 'Cart (' + n + ' item' + (n === 1 ? '' : 's') + ')');
      }
    }

    function refresh() {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCount(cart.item_count); return cart; });
    }

    function add(id, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity || 1 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function (item) {
          return refresh().then(function () { return item; });
        });
    }

    var hideTimer = null;
    function toast(opts) {
      opts = opts || {};
      var region = document.getElementById('sq-toast-region');
      if (!region) return;
      region.innerHTML = '';

      var card = document.createElement('div');
      card.className = 'sq-toast' + (opts.status === 'error' ? ' sq-toast--error' : '');

      var media = '';
      if (opts.image) {
        media = '<img class="sq-toast__img" src="' + opts.image + '" alt="" width="48" height="48">';
      }
      var icon = opts.status === 'error' ? 'error' : 'check_circle';
      card.innerHTML =
        media +
        '<div class="sq-toast__body">' +
          '<span class="sq-toast__head"><span class="material-symbols-outlined" aria-hidden="true">' + icon + '</span>' +
            (opts.heading || (opts.status === 'error' ? "Couldn't add to cart" : 'Added to your stash')) + '</span>' +
          (opts.title ? '<span class="sq-toast__title">' + opts.title + '</span>' : '') +
        '</div>' +
        (opts.status === 'error' ? '' : '<a class="sq-toast__link" href="/cart">View cart</a>');

      region.appendChild(card);
      // Force reflow so the entrance transition runs.
      void card.offsetWidth;
      card.classList.add('is-visible');

      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () {
        card.classList.remove('is-visible');
        window.setTimeout(function () { if (card.parentNode) card.parentNode.removeChild(card); }, 300);
      }, 4000);
    }

    // Keep the badge correct if the page was restored from bfcache.
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

    return { add: add, refresh: refresh, setCount: setCount, toast: toast };
  })();

  // Delegated quick-add for any [data-quick-add] control (cards, etc.)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    var iconEl = btn.querySelector('.material-symbols-outlined');
    var isText = !iconEl && btn.textContent.trim().length > 0;
    var prevIcon = iconEl ? iconEl.textContent : null;
    var prevText = isText ? btn.textContent : null;

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    window.SquirrellyCart.add(id, 1).then(function (item) {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.removeAttribute('aria-busy');
      if (iconEl) iconEl.textContent = 'check';
      else if (isText) btn.textContent = 'Added ✓';
      window.SquirrellyCart.toast({
        title: item.product_title || item.title,
        image: item.image,
        status: 'success'
      });
      window.setTimeout(function () {
        btn.classList.remove('is-added');
        if (iconEl && prevIcon) iconEl.textContent = prevIcon;
        else if (isText && prevText) btn.textContent = prevText;
      }, 1800);
    }).catch(function (err) {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      window.SquirrellyCart.toast({
        status: 'error',
        title: (err && err.description) || 'Please try again.'
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
